export default __webpack_public_path__ + "static/media/FaceDonateScalesImage.110e13eb.png";